import React, { useRef, useState, useEffect } from "react"
import { Modal } from "antd"
import SignatureCanvas from "react-signature-canvas"
import { useNavigate, useLocation } from "react-router-dom"
import { UsePostRequest } from "../../utils/api/ApiRequests"
import { getUser, getToken, capitalizeEachWord, getIsAdminLogin, getIsEmployeeLogin, getIsHRLogin } from "../../utils/Common"
import { Button, Row, Col, Divider } from "antd"
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons"
import { Container } from "react-bootstrap"
import ReactToPrint from "react-to-print"
import Navbar from "../../components/Navbar/Navbar"
import logo2 from "../../assets/images/logo2.png"
import dayjs from "dayjs"

// Helper to display a labeled field as plain text (no input/dropdown)
const Field = ({ value }) => (
  <span style={{ display: "block", minHeight: 18, padding: "1px 0", fontSize: "0.82rem", wordBreak: "break-word", whiteSpace: "pre-wrap" }}>
    {value || "—"}
  </span>
)

const SectionHeader = ({ title }) => (
  <Row className="mt-4 mb-1">
    <Col xs={24}>
      <span className="primary-color bold" style={{ fontSize: "0.8rem" }}>{title}</span>
    </Col>
  </Row>
)

const loanTypeMap = {
  sss_salary_loan:   "SSS Salary Loan",
  sss_calamity_loan: "SSS Calamity Loan",
  company_loan:      "Company Loan",
  cooperative_loan:  "Cooperative Loan",
  pag_ibig_loan:     "Pag-IBIG Loan",
  laptop_loan:       "Laptop Loan",
  cash_advance:      "Cash Advance",
  phone_loan:        "Phone Loan",
  calamity_loan:     "Calamity Loan",
  others:            "Others",
}

const termMap = {
  per_payroll: "Per Payroll",
  end_month:   "End Month",
}

const formatDate = (val) =>
  val ? dayjs(val).format("MMMM DD, YYYY") : "—"

const formatAmount = (val) =>
  val
    ? parseFloat(val).toLocaleString("en-PH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "—"

    const SignaturePadModal = ({ open, onCancel, onSubmit, title }) => {
  const sigRef = useRef(null)
  const handleClear = () => sigRef.current?.clear()
  const handleSubmit = () => {
    if (sigRef.current && !sigRef.current.isEmpty()) {
      onSubmit(sigRef.current.toDataURL("image/png"))
    }
  }
  return (
    <Modal
      open={open}
      title={<span className="primary-color">{title}</span>}
      onCancel={onCancel}
      footer={
        <Row className="d-flex justify-content-between">
          <Button onClick={handleClear}>Clear</Button>
          <Row className="gap-2">
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" onClick={handleSubmit}>Submit</Button>
          </Row>
        </Row>
      }
      centered
      width="90%"
      style={{ maxWidth: 480 }}
    >
      <div className="border rounded" style={{ background: "transparent", overflowX: "auto" }}>
        <SignatureCanvas
          ref={sigRef}
          penColor="black"
          canvasProps={{
          width: 430,
          height: 180,
          className: "sig-canvas",
          style: { background: "transparent", maxWidth: "100%", display: "block" },
        }}
        />
      </div>
      <p className="tiny-text mt-1">Draw your signature above</p>
    </Modal>
  )
}

export default function ViewLoanForm() {
  const navigate = useNavigate()
  const { state: rowData } = useLocation()
  const componentRef = useRef()

  const d = rowData || {}
  const isAdminLogin = getIsAdminLogin()
  const isEmployeeLogin = getIsEmployeeLogin()
  const isHRLogin = getIsHRLogin()

  const [loanData, setLoanData] = useState(d)
  const [requesterSig, setRequesterSig] = useState(d.requester_signature || null)
  const [approverSig, setApproverSig] = useState(d.approver_signature || null)
  const [approverName, setApproverName] = useState(d.approver_name || "")
  const [showRequesterSigModal, setShowRequesterSigModal] = useState(false)
  const [showApproverSigModal, setShowApproverSigModal] = useState(false)
  const [isSavingSig, setIsSavingSig] = useState(false)

  const handleSaveSignature = async (sigData, field) => {
  setIsSavingSig(true)
  let currentApproverName = approverName
  if (field === "approver_signature") {
    const res = await UsePostRequest("users/get", { user_id: getUser() })
    if (res.data && res.data[0]) {
      currentApproverName = res.data[0].name || ""
      setApproverName(currentApproverName)
    }
  }
  const payload = {
    employee_loan_id: d.id,
    [field]: sigData,
    ...(field === "approver_signature" && { approver_name: currentApproverName }),
  }
  const response = await UsePostRequest("employee_loans/update_signature", payload)
    if (field === "requester_signature") setRequesterSig(sigData)
    if (field === "approver_signature") setApproverSig(sigData)
  setIsSavingSig(false)
}

   useEffect(() => {
  async function init() {
    if (d.id) {
      const res = await UsePostRequest("employee_loans/get", { employee_loan_id: d.id })
      if (res.data && res.data[0]) {
        const fresh = res.data[0]
        setLoanData(fresh)
        setRequesterSig(fresh.requester_signature || null)
        setApproverSig(fresh.approver_signature || null)
        if (fresh.approver_name) setApproverName(fresh.approver_name)

        // fetch requester name from users table
        const userRes = await UsePostRequest("users/get", { employee_id: fresh.employee_id })
        if (userRes.data && userRes.data[0]) {
          setLoanData((prev) => ({ ...prev, employee_name: userRes.data[0].name }))

        // set approver name from DB if exists
        if (fresh.approver_name) {
          setApproverName(fresh.approver_name)
        } else if (isAdminLogin || isHRLogin) {
          // fallback: fetch logged-in admin's name
          const adminRes = await UsePostRequest("users/get", { user_id: getUser() })
          if (adminRes.data && adminRes.data[0]) {
            setApproverName(adminRes.data[0].name || "")
          }
        }
      }
    }
  }
}
  init()
}, [])
    
  return (
    <Navbar>
      {/* ── Action Buttons (no print) ── */}
      <Row className="mb-3 noPrint" style={{ gap: 8 }}>
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate("/loans")}
        >
          Back to Loans
        </Button>

        <ReactToPrint
          trigger={() => (
            <Button type="primary" icon={<PrinterOutlined />}>
              Print
            </Button>
          )}
          content={() => componentRef.current}
          documentTitle={`LoanForm_${loanData.employee_name || "unknown"}`}
         pageStyle={`
          @page {
            size: A4 portrait;
            margin: 0;
          }
          @media print {
            body { -webkit-print-color-adjust: exact; }
            .noPrint { display: none !important; }
            table { font-size: 0.78rem !important; }
            td { padding: 3px 6px !important; }
            .loan-form-logo {
            height: 80px !important;
            width: auto !important;
            }
            .loan-form-header {
              margin-bottom: 8px !important;
            }
            .loan-form-divider-wrapper {
              margin-top: 0 !important;
            }
          }
        `}
        />
      </Row>

      {/* Printable Content */}
      <Container
      ref={componentRef}
      className="print-report-page px-4 pb-2 view-page"
      style={{ maxWidth: 900, paddingTop: 0 }}
       >
        <Row className="d-flex justify-content-center align-items-center mb-0 loan-form-header">
        <img src={logo2} alt="logo" className="me-3 loan-form-logo" style={{ height: 150, width: "auto" }} />
        <Col>
          <Row className="bold" style={{ fontSize: "1.05rem" }}>{window.$company_name}</Row>
          <Row style={{ fontSize: "0.82rem" }}>{window.$company_address}</Row>
        </Col>
      </Row>

       <div style={{ marginTop: -50 }} className="loan-form-divider-wrapper">
      <Divider className="black-divider" style={{ margin: "0"}} />
      </div>

       
       <Row className="d-flex justify-content-center mt-5 mb-2">
      <span className="primary-color bold uppercase" style={{ fontSize: "1.2rem", letterSpacing: "0.05em" }}>
        CASH ADVANCE / LOAN FORM
      </span>
      </Row>

        {/* Employee Info  */}
        <Row className="px-1 mb-3">
          <table className="table table-bordered w-100 mb-0" style={{ fontSize: "0.82rem" }}>
            <tbody>
              <tr>
                <td className="bold w-25" style={tdStyle}>Employee Name</td>
                <td className="w-25" style={tdStyle}><Field value={loanData.employee_name} /></td>
                <td className="bold w-25" style={tdStyle}>Request Date</td>
                <td className="w-25" style={tdStyle}><Field value={formatDate(loanData.issue_date)} /></td>
              </tr>
              <tr>
                <td className="bold" style={tdStyle}>Position</td>
                <td style={tdStyle}><Field value={loanData.position} /></td>
                <td className="bold" style={tdStyle}>Area / Dept</td>
                <td style={tdStyle}><Field value={loanData.area_dept} /></td>
              </tr>
            </tbody>
          </table>
        </Row>

        {/* Request Details */}
        <SectionHeader title="REQUEST DETAILS" />
        <Row className="px-1 mb-3">
          <table className="table table-bordered w-100 mb-0" style={{ fontSize: "0.82rem" }}>
            <tbody>
              <tr>
                <td className="bold w-25" style={tdStyle}>Loan Type</td>
                <td className="w-25" style={tdStyle}>
                  <Field value={loanTypeMap[loanData.loan_type] || loanData.loan_type} />
                </td>
                <td className="bold w-25" style={tdStyle}>Amount</td>
                <td className="w-25" style={tdStyle}>
                  <Field value={formatAmount(loanData.loan_amount)} />
                </td>
              </tr>
              <tr>
                <td className="bold align-top" style={tdStyle}>Purpose</td>
                <td style={{ ...tdStyle, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                <Field value={loanData.reason} />
                </td>
                <td className="bold align-top" style={tdStyle}>Date Needed</td>
                <td style={tdStyle}><Field value={formatDate(loanData.date_needed)} /></td>
              </tr>
            </tbody>
          </table>
        </Row>

        {/*  Salary Deduction Details  */}
        <SectionHeader title="SALARY DEDUCTION DETAILS" />
        <Row className="px-1 mb-3">
          <table className="table table-bordered w-100 mb-0" style={{ fontSize: "0.82rem" }}>
            <tbody>
              <tr>
                <td className="bold w-25" style={tdStyle}>Term</td>
                <td colSpan={3} style={tdStyle}>
                  <Field value={termMap[loanData.term] || loanData.term} />
                </td>
              </tr>
              <tr>
                <td className="bold w-25" style={tdStyle}>Total Approved Amount</td>
                <td className="w-25" style={tdStyle}>
                  <Field value={formatAmount(loanData.installment)} />
                </td>
                <td className="bold w-25" style={tdStyle}>Deduction per Payday</td>
                <td className="w-25" style={tdStyle}>
                  <Field value={formatAmount(loanData.charge_per_installment)} />
                </td>
              </tr>
              <tr>
                <td className="bold" style={tdStyle}>First Deduction Date</td>
                <td style={tdStyle}><Field value={formatDate(loanData.first_deduction_date)} /></td>
                <td className="bold" style={tdStyle}>Estimated Last Deduction Date</td>
                <td style={tdStyle}><Field value={formatDate(loanData.estimated_last_deduction_date)} /></td>
              </tr>
            </tbody>
          </table>
        </Row>

        {/* Acknowledgement  */}
        <SectionHeader title="ACKNOWLEDGEMENT" />
        <Row className="px-1 mb-5">
          <p style={{ fontSize: "0.8rem", lineHeight: 1.6, marginBottom: 0 }}>
            I hereby acknowledge that the amount stated above is a cash
            advance/loan from the company. I authorize the company to deduct
            the specified amount from my salary every payday until the loan
            is fully paid.
          </p>
        </Row>

        {/*  Signatures  */}
        <Row gutter={[48, 0]} className="px-1 mt-2">
          {/* Requested by */}
          <Col xs={24} sm={12}>
            <div style={sigBlockStyle}>
              <div className="bold mb-1" style={{ fontSize: "0.8rem" }}>
                Requested by:
              </div>
              <div style={sigSpaceStyle}>
                {requesterSig ? (
                  <img
                    src={requesterSig}
                    alt="signature"
                    style={{ maxHeight: 64, maxWidth: "100%", display: "block", margin: "0 auto" }}
                  />
                ) : isEmployeeLogin && (
                  <Button
                    size="small"
                    className="noPrint"
                    onClick={() => setShowRequesterSigModal(true)}
                    style={{ display: "block", margin: "0 auto" }}
                  >
                    Add Signature
                  </Button>
                )}
              </div>
              <div style={sigLineContainerStyle}>
                <div style={sigNameStyle}>
                  {loanData.employee_name
                  ? (() => {
                      const parts = loanData.employee_name.split(",")
                      const lastName = parts[0]?.trim()
                      const rest = parts[1]?.trim()
                      return rest ? `${rest} ${lastName}`.toUpperCase() : loanData.employee_name.toUpperCase()
                    })()
                  : "___________________________"}
                </div>
                <div style={sigUnderlineStyle} />
                <div style={sigLabelStyle}>Signature over Printed Name</div>
              </div>
            </div>
          </Col>

            {/* Approved by */}
            <Col xs={24} sm={12}>
              <div style={sigBlockStyle}>
                <div className="bold mb-1" style={{ fontSize: "0.8rem" }}>
                  Approved by:
                </div>
                <div style={sigSpaceStyle}>
                  {approverSig ? (
                    <img
                      src={approverSig}
                      alt="signature"
                      style={{ maxHeight: 64, maxWidth: "100%", display: "block", margin: "0 auto" }}
                    />
                  ) : (isAdminLogin || isHRLogin) && (
                    <Button
                      size="small"
                      className="noPrint"
                      onClick={() => setShowApproverSigModal(true)}
                      style={{ display: "block", margin: "0 auto" }}
                    >
                      Add Signature
                    </Button>
                  )}
                </div>
              <div style={sigLineContainerStyle}>
                <div style={sigNameStyle}>
                  {approverName
                    ? capitalizeEachWord(approverName).toUpperCase()
                    : "___________________________"}
                </div>
                <div style={sigUnderlineStyle} />
                <div style={sigLabelStyle}>Signature over Printed Name</div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    <SignaturePadModal
        open={showRequesterSigModal}
        title="Draw Requester Signature"
        onCancel={() => setShowRequesterSigModal(false)}
        onSubmit={(sig) => {
          handleSaveSignature(sig, "requester_signature")
          setShowRequesterSigModal(false)
        }}
      />
      <SignaturePadModal
        open={showApproverSigModal}
        title="Draw Approver Signature"
        onCancel={() => setShowApproverSigModal(false)}
        onSubmit={(sig) => {
          handleSaveSignature(sig, "approver_signature")
          setShowApproverSigModal(false)
        }}
      />
    </Navbar>
  )
}

// ── Styles ────────────────────────────────────────────────────────────────────

const tdStyle = {
  padding: "3px 8px",
  verticalAlign: "middle",
}

const sigBlockStyle = {
  padding: "8px 16px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  minHeight: 140,
}

const sigSpaceStyle = {
  flex: 1,
  minHeight: 64,
}

const sigLineContainerStyle = {
  marginTop: "auto",
  textAlign: "center",
}

const sigNameStyle = {
  fontWeight: "bold",
  fontSize: "0.8rem",
  marginBottom: 2,
  minHeight: 18,
}

const sigUnderlineStyle = {
  borderTop: "1px solid black",
  margin: "0 16px 4px",
}

const sigLabelStyle = {
  fontSize: "0.68rem",
  color: "#555",
}